// src/features/home/components/ChinarLeaf.tsx

interface ChinarLeafProps {
  className?: string;
}

/**
 * Large decorative chinar leaf illustration.
 * Classic 5-lobed chinar (maple-family) silhouette with internal veining.
 * Designed to sit in the bottom-left of the hero cream card at low opacity.
 */
export default function ChinarLeaf({ className = "" }: ChinarLeafProps) {
  return (
    <svg viewBox="0 0 400 400" className={className} aria-hidden fill="none">
      <g
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      >
        {/* Main leaf outline — classic 5-pointed chinar with serrations */}
        <path
          d="
            M 200 360
            L 200 250
            L 130 285
            L 150 215
            L 70 210
            L 120 160
            L 70 110
            L 130 115
            L 110 50
            L 170 95
            L 200 40
            L 230 95
            L 290 50
            L 270 115
            L 330 110
            L 280 160
            L 330 210
            L 250 215
            L 270 285
            L 200 250
          "
        />

        {/* Central vein (petiole to tip) */}
        <path d="M 200 360 L 200 50" strokeWidth="1" />

        {/* Left-upper lobe veins */}
        <path d="M 200 150 L 110 60" strokeWidth="0.8" />
        <path d="M 200 180 L 85 130" strokeWidth="0.8" />
        <path d="M 200 210 L 95 185" strokeWidth="0.8" />

        {/* Right-upper lobe veins */}
        <path d="M 200 150 L 290 60" strokeWidth="0.8" />
        <path d="M 200 180 L 315 130" strokeWidth="0.8" />
        <path d="M 200 210 L 305 185" strokeWidth="0.8" />

        {/* Lower lobe veins */}
        <path d="M 200 250 L 145 275" strokeWidth="0.8" />
        <path d="M 200 250 L 255 275" strokeWidth="0.8" />

        {/* Secondary veins (detail) */}
        <path d="M 200 130 L 155 85" strokeWidth="0.5" strokeOpacity="0.8" />
        <path d="M 200 130 L 245 85" strokeWidth="0.5" strokeOpacity="0.8" />
        <path d="M 200 195 L 130 175" strokeWidth="0.5" strokeOpacity="0.8" />
        <path d="M 200 195 L 270 175" strokeWidth="0.5" strokeOpacity="0.8" />

        {/* Stem */}
        <path d="M 200 360 L 200 395" strokeWidth="1.4" />
      </g>
    </svg>
  );
}